
        var result = require("!!../../../../../node_modules/css-loader/index.js!./bookmarks-dialog.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/bookmark-templates/bookmarks-dialog/bookmarks-dialog.component.css
// module id = 762
// module chunks = 0